// The workspace-level `cyborg:sync` cursor (CYBORG-1205 item 1). Invariant: every row
// with `seq <= cursor` is held by this tab or was drained. A drained page moves it
// (`advanceTo`); a live broadcast moves it ONLY when it is exactly `cursor + 1`, so a
// hole (a row this socket never got) keeps the cursor below it and the next drain reads
// across it. Jumping to the live max would lose that row, like a truncated `after` cursor.

export class WorkspaceSyncCursor {
  readonly #byWs = new Map<string, number>();

  get(workspaceId: string): number {
    return this.#byWs.get(workspaceId) ?? 0;
  }

  /** Every row with seq <= `seq` is held (a drained page, a persisted high-water). */
  advanceTo(workspaceId: string, seq: number): boolean {
    if (!Number.isFinite(seq) || seq <= this.get(workspaceId)) return false;
    this.#byWs.set(workspaceId, seq);
    return true;
  }

  /** A live seq reached this tab. Never seeds an unset cursor: rows below it are unproven. */
  observeLive(workspaceId: string, seq: number): boolean {
    const cur = this.get(workspaceId);
    if (cur <= 0 || seq !== cur + 1) return false;
    this.#byWs.set(workspaceId, seq);
    return true;
  }

  clear(): void {
    this.#byWs.clear();
  }
}
